import { render, staticRenderFns } from "./OrderViewActionCancelEdition.vue?vue&type=template&id=eda18a24&"
import script from "./OrderViewActionCancelEdition.vue?vue&type=script&lang=js&"
export * from "./OrderViewActionCancelEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports